import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import { UploadWizardService } from './wizard.service';
import { NewStoryService } from '../new/new.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, Observable } from 'rxjs';
import * as sharedActions from '../../shared/shared.actions';
import { Store } from '@ngrx/store';
import * as fromApp from '../../app.reducer';

@Component({
  selector: 'upload-wizard-story',
  styleUrls: ['./wizard.component.scss'],
  templateUrl: './wizard.component.html',
})
export class UploadWizardStoryComponent implements OnInit, OnDestroy {
  step = 1;
  totalSteps = 5;
  isOrderSubmitting: boolean;
  cancelUploadingConfirmationMessage;
  subscriptions = new Subscription();
  showConfirmLeavePage;
  redirectUrl;
  isMobile;
  projectId: null | string;
  isProjectUpdating: null | boolean;

  @HostListener('window:beforeunload', ['$event'])
  preventCancelUpload($event) {
    this.preventLeave($event);
  }

  constructor(
    public uploadWizardService: UploadWizardService,
    private newStoryService: NewStoryService,
    private router: Router,
    private translate: TranslateService,
    private store: Store<fromApp.AppState>
  ) {
    if (!this.newStoryService.images.length) {
      this.router.navigate(['/stories/new']);
    }
    this.translate.get('cancel_syncing_message').subscribe((res: string) => {
      this.cancelUploadingConfirmationMessage = res;
    });
    this.store.select('new').subscribe(storyUploading => {
      this.projectId = storyUploading.uploadingProjectId;
      this.isProjectUpdating = storyUploading.isProjectUpdating;
    });
  }

  ngOnInit() {
    this.subscriptions.add(
      this.newStoryService.designOptions.subscribe(designOptions => {
        this.uploadWizardService.applyDesignOptions(designOptions);
      })
    );
    this.store.dispatch(new sharedActions.CurrentPage('wizardPage'));
    this.store.select('shared').subscribe(store => {
      this.isMobile = store.isMobile;
    });
  }

  preventLeave($event) {
    if (this.isOrderSubmitting) {
      $event.returnValue = this.cancelUploadingConfirmationMessage;
      return this.cancelUploadingConfirmationMessage;
    }
  }

  public nextStep() {
    window.scrollTo(0, 0);
    let nextStep = this.step + 1;
    while (this.shouldSkipStep(nextStep)) {
      nextStep = nextStep + 1;
    }
    this.step = nextStep;
    if (this.step === 2) {
      this.uploadPhotos();
    }
  }

  public prevStep() {
    window.scrollTo(0, 0);
    let nextStep = this.step - 1;
    while (this.shouldSkipStep(nextStep)) {
      nextStep = nextStep - 1;
    }
    this.step = nextStep;
  }

  public submit() {
    this.newStoryService.createStory(
      this.uploadWizardService.details,
      this.uploadWizardService.specs
    );
  }

  public uploadPhotos() {
    this.isOrderSubmitting = true;
    this.newStoryService.startCreation(this.newStoryService.projectId, this.uploadWizardService.details);
  }

  public shouldSkipStep(step) {
    switch (step) {
      case 2:
        return (
          this.uploadWizardService.occasions &&
          this.uploadWizardService.occasions.length === 1 &&
          this.uploadWizardService.styles &&
          this.uploadWizardService.styles.length === 1
        );
      default:
        return false;
    }
  }

  onPromocodeActivated(code) {
    this.uploadWizardService.details.discount_code = code;
    // this.uploadWizardService.getBookformatsWithFallback();
  }

  showLeavePageModal() {
    this.showConfirmLeavePage = true;
  }

  confirmLeavingPage() {
    this.newStoryService.cancelUploading(this.redirectUrl);
    this.showConfirmLeavePage = false;
  }

  stayOnPage() {
    this.redirectUrl = '';
    this.showConfirmLeavePage = false;
  }

  canDeactivate(nextState: RouterStateSnapshot): Observable<boolean> | boolean {
    if (
      nextState.url !== '/stories/designing' &&
      nextState.url !== '/account/login' &&
      !this.newStoryService.uploadCancelled &&
      this.newStoryService.images.length
    ) {
      this.showLeavePageModal();
      this.redirectUrl = nextState.url;
      return false;
    }
    return true;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    this.uploadWizardService.designOptionsApplied = false;
    this.store.dispatch(new sharedActions.CurrentPage(''));
  }
}
